import "../LandingPage.css";

export default function Schools() {
  return (
    <>
      {/* BusBuddy Header Section */}
      <section className="section-header padding-bottom" id="busbuddySection">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8 col-md-8 col-sm-12 col-12">
              <div className="section-header-content">
                <h2>
                  <span style={{ color: "var(--orange-color)" }}>BusBuddy</span>{" "}
                  -
                  <span style={{ color: "var(--primary-color)" }}>
                    {" "}
                    School Transportation
                  </span>
                </h2>
                <p>
                  Smart & Reliable Mobility Solution for Schools, Students &
                  Parents
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12 col-12">
              <div className="section-header-image text-center">
                <img
                  src="/assets/images/Hero-bg-2.png"
                  alt="BusBuddy"
                  className="img-fluid"
                  style={{ maxHeight: "120px" }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section padding-bottom">
        <div className="container">
          <div className="section-title">
            <h2> Features </h2>
          </div>
          <div className="row">
            {[
              {
                img: 1,
                title: "Parent App",
                text: "A Simple, very easy to use Parent's App to give them live update on child's journey from home to Institute and back.",
              },
              {
                img: 2,
                title: "Driver App",
                text: "A very easy Driver's App to show them their routes and provide navigation to pick students.",
              },
              {
                img: 3,
                title: "Admin Dashboard",
                text: "An intuitive Dashboard for School or Institute Transport Admin to monitor Live Trips, historical trips and have a deep analysis of the Institute buses functioning.",
              },
              {
                img: 4,
                title: "Live Location Tracking",
                text: "Parent and Institute can view live location of the bus and route it has taken during the trip.",
              },
              {
                img: 5,
                title: "Geofencing",
                text: "Child's pickup location, drop location and Institute are Geofenced for child's security.",
              },
              {
                img: 6,
                title: "Speed Alerts",
                text: "Institute’s transport admin and parents gets a high-speed alert when bus crosses the speed limits set along with location.",
              },
              {
                img: 7,
                title: "Bus Breakdown Alerts",
                text: "Institute transport admin will get alerts in an unforeseen event of bus break down with precise location to take quick actions to ensure child's safety.",
              },
              {
                img: 8,
                title: "Route Update",
                text: "Parent and Institute transport admin will get an alert if bus deviates from the set route.",
              },
            ].map((f, idx) => (
              <div
                className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12"
                key={idx}
              >
                <div className="feature-box">
                  <div className="feature-inner">
                    <div className="feature-img">
                      <img
                        src={`/assets/images/feature-${f.img}.png`}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="feature-details">
                      <h3>{f.title}</h3>
                      <p>{f.text}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="benefits-section padding-bottom">
        <div className="container">
          <div className="section-title">
            <h2> Benefits for parents </h2>
          </div>
          <div className="row">
            {[
              {
                img: 1,
                title: "Safety Alerts",
                text: "Instant notifications are sent to parent when kid boards the bus, reaches the Institute, leaves from the Institute and reaches home.",
              },
              {
                img: 2,
                title: "Proximity Alerts",
                text: "Parent will get notification when bus is near to pick up or drop locations with estimated time of arrival and distance from the location. Saving them wait time on the road.",
              },
              {
                img: 3,
                title: "Live Tracking",
                text: "Parent can track the live location of the bus on parent's app. App will show estimated time of arrival and distance from the location of pick up or drop.",
              },
              {
                img: 4,
                title: "Emergency Alerts",
                text: "Parent will be alerted in any unforeseen events or delay in arrival or departure of the bus.",
              },
              {
                img: 5,
                title: "Contact the Driver",
                text: "In case of need, Parent can call driver from the parent's App directly.",
              },
              {
                img: 6,
                title: "Easy to use",
                text: "A very intuitive easy to use App on Android and iOS platform.",
              },
            ].map((b, idx) => (
              <div
                className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12"
                key={idx}
              >
                <div className="benefits-box">
                  <div className="benefits-inner">
                    <div className="benefits-img">
                      <img
                        src={`/assets/images/Benefits-ic-${b.img}.png`}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="benefits-details">
                      <h3>{b.title}</h3>
                      <p>{b.text}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="schools-section padding-bottom">
        <div className="container">
          <div className="section-title">
            <h2> Benefits for Schools </h2>
          </div>
          <div className="row">
            {[
              {
                img: 1,
                title: "Intelligent Route Mapping",
                text: "AI Powered route mapping engine of App can auto create optimized routes for multiple buses. Routes can also be created manually.",
              },
              {
                img: 2,
                title: "Security Parameters",
                text: "Admin can set host of security parameters in the system, like Speed Limits, route information, driver and attendant's personal information, Bus information etc.",
              },
              {
                img: 3,
                title: "Smart Dashboards",
                text: "Visually compelling Dashboard to take a deep dive in to the Bus utilization data.",
              },
              {
                img: 4,
                title: "Reports",
                text: "Report like precise distance a bus travels during the given period, time taken to complete the route, number of students per bus etc, can help save on fuel management, route and time efficiency.",
              },
              {
                img: 5,
                title: "Live Bus Tracking",
                text: "Admin can track live location of the buses and student's data. Can see estimated time of arrival and distance from the location of pick up or drop.",
              },
              {
                img: 6,
                title: "Cost Savings",
                text: "With Zero hardware investment and lesser human efforts, Institute can maximize on saving transport operation costs.",
              },
            ].map((s, idx) => (
              <div
                className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 d-flex"
                key={idx}
              >
                <div className="benefits-box">
                  <div className="benefits-inner schools-inner">
                    <div className="benefits-img">
                      <img
                        src={`/assets/images/schools-ic-${s.img}.png`}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="benefits-details">
                      <h3>{s.title}</h3>
                      <p>{s.text}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
